import NavigationIcon from '@mui/icons-material/Navigation';
import { SxProps, Theme } from '@mui/material';

type WindDirectionIconProps = {
  degrees: number;
  sx?: SxProps<Theme>;
};

export const WindDirectionIcon = (
  props: WindDirectionIconProps,
): JSX.Element | null => {
  const { degrees, sx } = props;
  return (
    <NavigationIcon sx={{ fontSize: 16, rotate: `${degrees}deg`, ...sx }} />
  );
};
